import type { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const CodeSnippet: FC<Props> = ({ children }) => {
  return <div className="bg-grey-lighter p-2 rounded-xs text-sm font-mono leading-none">{children}</div>;
};

export default CodeSnippet;
